import { createContext, type PropsWithChildren, useMemo } from 'react';
import { de, enGB, Locale } from 'date-fns/locale';

type Languages = Record<string, { locale: Locale; name: string }>;

export interface I18nContextType {
  resolvedLanguage: string;
  t: (key: string, options?: Record<string, unknown>) => string;
  languages: Languages;
}

export const I18nContext = createContext<I18nContextType | null>(null);

export const I18nProvider = ({
  children,
  i18n,
  languages,
}: PropsWithChildren<{ i18n: I18nContextType; languages?: Languages }>) => {
  const value = useMemo<I18nContextType>(() => {
    return {
      resolvedLanguage: i18n.resolvedLanguage,
      t: typeof i18n.t === 'function' ? i18n.t : (key) => key,
      languages: languages
        ? languages
        : {
            de: {
              name: 'Deutsch',
              locale: de,
            },
            en: {
              name: 'English',
              locale: enGB,
            },
          },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.resolvedLanguage, languages]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};
